import { ReactNode, SVGProps, useMemo } from "react";
import { ReactComponent as BgPatternCirclesSm } from "#src/assets/images/v2/backgroundPatterns/circles-sm.svg";

interface IModalHeaderIconProps {
  type?: "brand" | "gray" | "success" | "warning" | "error";
  Icon: (props: SVGProps<SVGSVGElement>) => ReactNode;
}

export const ModalHeaderIcon = ({
  type = "brand",
  Icon,
}: IModalHeaderIconProps) => {
  // --------------- COMPUTED ---------------

  const divColorTwClasses = useMemo(() => {
    if (type === "brand") return "bg-brand-v2-100 border-brand-v2-50";
    if (type === "gray") return "bg-gray-v2-100 border-gray-v2-50";
    if (type === "success") return "bg-success-v2-100 border-success-v2-50";
    if (type === "warning") return "bg-warning-v2-100 border-warning-v2-50";
    if (type === "error") return "bg-error-v2-100 border-error-v2-50";
    // default is returning brand color
    return "bg-brand-v2-100 border-brand-v2-50";
  }, [type]);

  const iconColorTwClasses = useMemo(() => {
    if (type === "brand") return "text-brand-v2-600";
    if (type === "gray") return "text-gray-v2-600";
    if (type === "success") return "text-success-v2-600";
    if (type === "warning") return "text-warning-v2-600";
    if (type === "error") return "text-error-v2-600";
    // default is returning brand color
    return "bg-brand-v2-50 border-brand-v2-100";
  }, [type]);

  // --------------- RENDER ---------------

  return (
    <div
      className={`relative h-[3.25rem] w-[3.25rem] min-w-[3.25rem] flex items-center justify-center rounded-full border-[0.5rem] ${
        divColorTwClasses
      }`}
    >
      <Icon className={`h-6 w-6 min-w-6 ${iconColorTwClasses}`} />
      <BgPatternCirclesSm
        className={`absolute h-[21rem] w-[21rem] min-w-[21rem]`}
      />
    </div>
  );
};
